import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import moment from 'moment'
import './HomeView.scss'

class HomeView extends Component {
  constructor (props) {
    super(props)
    this.state = { performer: '', address: '', lat: '', lng: '' }
    this.onChange = (address) => this.setState({ address })
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  handleInputChange (event) {
    const target = event.target
    const value = target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }

  handleSelect (address) {
    this.setState({
      address,
      loading: true
    })

    geocodeByAddress(address)
     .then((results) => getLatLng(results[0]))
     .then(({ lat, lng }) => {
       console.log('Success Yay', { lat, lng })
       this.setState({
         lat,
         lng
       })
     })
     .catch((error) => {
       console.log('Oh no!', error)
     })
  }

  renderEvent (event, index) {
    return (
      <div className='col-lg-6'>
        <div className='item item-big'>
          <div className='image'><img src={event.imageURL} alt='...' className='img-fluid' /></div>
          <div className='info d-flex align-items-end'>
            <div className='content'>
              <h3>{event.performer} at {event.venue}</h3>
              <p>{event.timeStamp}</p>
              <ul className='' style={{ listStyle: 'none' }}>
                {
                               event.prices.map(site => {
                                 return <li className='' style={{ paddingTop: 10, paddingBotom: 10 }}>${site.price} - {site.siteName} <a target='_blank' href={site.url} className='btn btn-primary'>Buy</a></li>
                               })
                             }
              </ul>
            </div>
          </div>
        </div></div>

      // <div className='col-md-6'>
      //   <div className='item'>
      //     <div className='image'><img src={event.imageURL} alt='...' className='img-fluid' /></div>
      //     <div className='info d-flex align-items-end'>
      //       <div className='content'>
      //         <h4>{event.performer} at {event.venue}</h4>
      //         <h5>{moment(event.timeStamp).format('MMM Do, YYYY')}</h5>
      //         <ul className='' style={{ listStyle: 'none' }}>
      //           {
      //                 event.prices.map(site => {
      //                   return <li className=''>${site.price} - {site.siteName} <a target='_blank' href={site.url} className='btn btn-primary'>Buy</a></li>
      //                 })
      //               }
      //         </ul>
      //       </div>
      //     </div>
      //   </div>
      //
      // </div>

    )
  }

  onSubmit () {
    this.props.getPrice(this.state.performer, { lat: this.state.lat, lng: this.state.lng }, this.state.address)
  }

  render () {
    const inputProps = {
      value: this.state.address,
      onChange: this.onChange,
    }

    const defaultStyles = {
      autocompleteContainer: {
        zIndex: 10000
      }
    }

    return (
      <div>
        <section style={{ background: "url('img/hero-2.jpg') no-repeat" }} className='hero d-flex align-items-center'>
          <div className='container'>
            <h1>Get the <span className='text-primary'>best</span> ticket price</h1>
            <p className='text-hero'>Find prices for an event across all the ticket sites</p>
            <div className='search-bar'>
              <form action='#'>
                <div className='row'>
                  <div className='form-group col-lg-5'>
                    <input type='search' name='performer' onChange={this.handleInputChange} placeholder='What are you searching for?' />
                  </div>
                  <div className='form-group col-lg-4'>
                    <PlacesAutocomplete styles={defaultStyles} onSelect={this.handleSelect} className='input' inputProps={inputProps} />
                    <label htmlFor='location' className='location'><i className='icon-localizer text-primary mr-1' /></label>
                  </div>
                  <div className='form-group col-lg-3'>
                    <input type='submit' onClick={(event) => {
                      event.preventDefault()
                      this.onSubmit()
                    }} value='Search' className='btn btn-primary submit' />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
        <section className='top-listings'>
          <div className='container'>
            <div className='row d-flex align-items-stretch'>

              {
                    this.props.isLoading &&
                      <div>Loading...</div>
                  }

              {
                    (this.props.hasLoaded && (this.props.events.length === 0)) &&
                    <div>Sorry, No Results Found!</div>
                  }

              {
                this.props.events.map((event, index) => {
                  return this.renderEvent(event, index)
                })
            }

            </div>
            {
            //  <div className='row' /><a href='#' className='btn btn-primary has-shadow has-wide-padding'>View More                                                                                                                                                                                                                                                                                  </a>
            }
          </div>

        </section>
        {
        // <section className='top-listings'>
        //   <div className='container'>
        //     <div className='row d-flex align-items-stretch'>
        //       <div className='row'>
        //         {this.props.events.map((event, index) => {
        //           return this.renderEvent(event, index)
        //         })}
        //       </div>
        //     </div>
        //   </div>
        // </section>
      }
      </div>
    )
  }
}
HomeView.propTypes = {

}
export default HomeView



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomeView.js